import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { WA_PHYSICS } from '../core/constants';
import type { TerrainDrawContext } from '../sim/maskCanvas';

export const GIRDER_SIZES = [
  { name: 'Small', length: 47, thickness: 8 },
  { name: 'Large', length: 125, thickness: 8 },
];

const GIRDER_COLOR = '#8B4513';

export const GIRDER_ANGLES = [0, 45, 90, 135];

export const WeaponGirder: WeaponDefinition = {
  id: 'girder',
  name: 'Girder',
  icon: 'girder.png',
  category: 'utility',
  maxAmmo: 3,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { target } = ctx;

    if (!target) {
      return {
        success: false,
        message: 'Select a location to place the girder',
      };
    }

    const waterY = WA_PHYSICS.WORLD.HEIGHT - WA_PHYSICS.WORLD.WATER_LEVEL;
    if (target.y > waterY - 20) {
      return {
        success: false,
        message: 'Cannot place girder in water',
      };
    }

    const isOutOfBounds =
      target.x < 50 ||
      target.x > WA_PHYSICS.WORLD.WIDTH - 50 ||
      target.y < 50 ||
      target.y > WA_PHYSICS.WORLD.HEIGHT - 100;

    if (isOutOfBounds) {
      return {
        success: false,
        message: 'Cannot place girder here',
      };
    }

    return {
      success: true,
      entities: [],
      message: 'Girder placed!',
    };
  },
};

export function drawGirderOnTerrain(
  ctx: TerrainDrawContext,
  centerX: number,
  centerY: number,
  angleDegrees: number,
  sizeIndex: number = 1,
): void {
  const size = GIRDER_SIZES[sizeIndex] || GIRDER_SIZES[1];
  const angleRad = (angleDegrees * Math.PI) / 180;
  const halfLength = size.length / 2;
  const halfThickness = size.thickness / 2;

  ctx.save();
  ctx.translate(centerX, centerY);
  ctx.rotate(angleRad);
  ctx.fillStyle = GIRDER_COLOR;
  ctx.fillRect(-halfLength, -halfThickness, size.length, size.thickness);
  ctx.restore();
}

export { GIRDER_COLOR };
